import AppError from "@/pages/errors/AppErrorPage";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import React, { FC, ReactNode, Suspense } from "react";
// import { ErrorBoundary } from "react-error-boundary";
import TopBarProgress from "react-topbar-progress-indicator";
import colors from "tailwindcss/colors";
import * as Sentry from "@sentry/react";

interface SuspenseRouteProps {
  children: ReactNode;
}

const SuspenseRoute: FC<SuspenseRouteProps> = ({ children }) => {
  const { reset } = useQueryErrorResetBoundary();
  const baseColor = colors.lime["600"];
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return (
    <Sentry.ErrorBoundary
      onReset={reset}
      fallback={({ resetError }) => <AppError handleCallback={resetError} />}
    >
      <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
    </Sentry.ErrorBoundary>
  );
};

export default SuspenseRoute;
